/**
 * @desc 批量新增
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.DataDimensionSourceValueAddBatchRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/data/add/batch`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
